import { Pipe, PipeTransform } from '@angular/core';
import { User } from 'src/app/shared/models/security/user';

@Pipe({
	name: 'filterUserByLoginOrNameOrProfile'
})
export class FilterUserByLoginOrNameOrProfilePipe implements PipeTransform {
	transform(value: User[], filter: string): User[] {
		if (
			!value ||
			!filter ||
			value === null ||
			filter === null ||
			filter === ''
		) {
			return value;
		}
		filter = filter.toLowerCase();

		return value.filter(
			(user) =>
				user.username.toLowerCase().includes(filter) ||
				user.firstName.toLowerCase().includes(filter) ||
				user.lastName.toLowerCase().includes(filter)
		);
	}
}
